module.exports = __webpack_public_path__ + "static/media/start_your_business.b8c1ef1c.webp";